import { phoneNumberRules } from 'constants/form'
import {
  allSymbolsAndEnglishLettersRegex,
  allSymbolsAndEnglishLettersWithoutSemicolonRegex,
  mailRegex,
} from 'constants/regex'
import { UserRoles } from 'constants/roles'
import { CONTACT_INFORMATION_FORM_VALUES } from 'texts/profileDetails'
import { FormValuesSetting } from 'types/form'

export const contactInformationValuesSetting: FormValuesSetting = {
  name: {
    required: {
      [UserRoles.Supplier]: true,
      [UserRoles.Operator]: true,
    },
    disabled: {
      [UserRoles.Supplier]: true,
      [UserRoles.Operator]: false,
    },
    validationRules: [
      {
        type: 'required',
        message: CONTACT_INFORMATION_FORM_VALUES.NAME.REQUIRED_MESSAGE,
      },
      {
        type: 'pattern',
        value: allSymbolsAndEnglishLettersRegex,
        message: CONTACT_INFORMATION_FORM_VALUES.NAME.VALIDATION_MESSAGE,
      },
    ],
  },
  postalCode: {
    required: {
      [UserRoles.Supplier]: true,
      [UserRoles.Operator]: true,
    },
    disabled: {
      [UserRoles.Supplier]: false,
      [UserRoles.Operator]: false,
    },
    validationRules: [
      {
        type: 'required',
        message: CONTACT_INFORMATION_FORM_VALUES.POSTAL_CODE.REQUIRED_MESSAGE,
      },
      {
        type: 'pattern',
        value: allSymbolsAndEnglishLettersRegex,
        message: CONTACT_INFORMATION_FORM_VALUES.POSTAL_CODE.VALIDATION_MESSAGE,
      },
      {
        type: 'pattern',
        value: allSymbolsAndEnglishLettersWithoutSemicolonRegex,
        message:
          CONTACT_INFORMATION_FORM_VALUES.POSTAL_CODE
            .ADDITIONAL_VALIDATION_MESSAGE,
      },
    ],
  },
  country: {
    required: {
      [UserRoles.Supplier]: true,
      [UserRoles.Operator]: true,
    },
    disabled: {
      [UserRoles.Supplier]: true,
      [UserRoles.Operator]: false,
    },
    validationRules: [
      {
        type: 'required',
        message: CONTACT_INFORMATION_FORM_VALUES.COUNTRY.REQUIRED_MESSAGE,
      },
    ],
  },
  street: {
    required: {
      [UserRoles.Supplier]: true,
      [UserRoles.Operator]: true,
    },
    disabled: {
      [UserRoles.Supplier]: false,
      [UserRoles.Operator]: false,
    },
    validationRules: [
      {
        type: 'required',
        message: CONTACT_INFORMATION_FORM_VALUES.STREET.REQUIRED_MESSAGE,
      },
      {
        type: 'pattern',
        value: allSymbolsAndEnglishLettersRegex,
        message: CONTACT_INFORMATION_FORM_VALUES.STREET.VALIDATION_MESSAGE,
      },
      {
        type: 'pattern',
        value: allSymbolsAndEnglishLettersWithoutSemicolonRegex,
        message:
          CONTACT_INFORMATION_FORM_VALUES.STREET.ADDITIONAL_VALIDATION_MESSAGE,
      },
    ],
  },
  building: {
    required: {
      [UserRoles.Supplier]: true,
      [UserRoles.Operator]: true,
    },
    disabled: {
      [UserRoles.Supplier]: false,
      [UserRoles.Operator]: false,
    },
    validationRules: [
      {
        type: 'required',
        message: CONTACT_INFORMATION_FORM_VALUES.BUILDING.REQUIRED_MESSAGE,
      },
      {
        type: 'pattern',
        value: allSymbolsAndEnglishLettersRegex,
        message: CONTACT_INFORMATION_FORM_VALUES.BUILDING.VALIDATION_MESSAGE,
      },
      {
        type: 'pattern',
        value: allSymbolsAndEnglishLettersWithoutSemicolonRegex,
        message:
          CONTACT_INFORMATION_FORM_VALUES.BUILDING
            .ADDITIONAL_VALIDATION_MESSAGE,
      },
    ],
  },
  city: {
    required: {
      [UserRoles.Supplier]: true,
      [UserRoles.Operator]: true,
    },
    disabled: {
      [UserRoles.Supplier]: false,
      [UserRoles.Operator]: false,
    },
    validationRules: [
      {
        type: 'required',
        message: CONTACT_INFORMATION_FORM_VALUES.CITY.REQUIRED_MESSAGE,
      },
      {
        type: 'pattern',
        value: allSymbolsAndEnglishLettersRegex,
        message: CONTACT_INFORMATION_FORM_VALUES.CITY.VALIDATION_MESSAGE,
      },
      {
        type: 'pattern',
        value: allSymbolsAndEnglishLettersWithoutSemicolonRegex,
        message:
          CONTACT_INFORMATION_FORM_VALUES.CITY.ADDITIONAL_VALIDATION_MESSAGE,
      },
    ],
  },
  mainMail: {
    required: {
      [UserRoles.Supplier]: true,
      [UserRoles.Operator]: true,
    },
    disabled: {
      [UserRoles.Supplier]: true,
      [UserRoles.Operator]: false,
    },
    validationRules: [
      {
        type: 'required',
        message: CONTACT_INFORMATION_FORM_VALUES.EMAIL.REQUIRED_MESSAGE,
      },
      {
        type: 'pattern',
        value: mailRegex,
        message: CONTACT_INFORMATION_FORM_VALUES.EMAIL.VALIDATION_MESSAGE,
      },
      {
        type: 'min',
        value: 5,
        message: CONTACT_INFORMATION_FORM_VALUES.EMAIL.VALIDATION_MESSAGE,
      },
    ],
  },
  contactPersonName: {
    required: {
      [UserRoles.Supplier]: true,
      [UserRoles.Operator]: true,
    },
    disabled: {
      [UserRoles.Supplier]: false,
      [UserRoles.Operator]: false,
    },
    validationRules: [
      {
        type: 'required',
        message:
          CONTACT_INFORMATION_FORM_VALUES.CONTACT_PERSON_NAME.REQUIRED_MESSAGE,
      },
      {
        type: 'pattern',
        value: allSymbolsAndEnglishLettersRegex,
        message:
          CONTACT_INFORMATION_FORM_VALUES.CONTACT_PERSON_NAME
            .VALIDATION_MESSAGE,
      },
    ],
  },
  brandName: {
    required: {
      [UserRoles.Supplier]: true,
      [UserRoles.Operator]: true,
    },
    disabled: {
      [UserRoles.Supplier]: false,
      [UserRoles.Operator]: false,
    },
    validationRules: [
      {
        type: 'required',
        message: CONTACT_INFORMATION_FORM_VALUES.BRAND_NAME.REQUIRED_MESSAGE,
      },
      {
        type: 'pattern',
        value: allSymbolsAndEnglishLettersRegex,
        message: CONTACT_INFORMATION_FORM_VALUES.BRAND_NAME.VALIDATION_MESSAGE,
      },
    ],
  },
  state: {
    required: {
      [UserRoles.Supplier]: false,
      [UserRoles.Operator]: false,
    },
    disabled: {
      [UserRoles.Supplier]: false,
      [UserRoles.Operator]: false,
    },
    validationRules: [
      {
        type: 'pattern',
        value: allSymbolsAndEnglishLettersRegex,
        message: CONTACT_INFORMATION_FORM_VALUES.STATE.VALIDATION_MESSAGE,
      },
      {
        type: 'pattern',
        value: allSymbolsAndEnglishLettersWithoutSemicolonRegex,
        message:
          CONTACT_INFORMATION_FORM_VALUES.STATE.ADDITIONAL_VALIDATION_MESSAGE,
      },
    ],
  },
  phone: {
    required: {
      [UserRoles.Supplier]: false,
      [UserRoles.Operator]: false,
    },
    disabled: {
      [UserRoles.Supplier]: false,
      [UserRoles.Operator]: false,
    },
    validationRules: phoneNumberRules,
  },
  phoneCor: {
    required: {
      [UserRoles.Supplier]: false,
      [UserRoles.Operator]: false,
    },
    disabled: {
      [UserRoles.Supplier]: false,
      [UserRoles.Operator]: false,
    },
    validationRules: [
      {
        type: 'required',
        message: CONTACT_INFORMATION_FORM_VALUES.PHONE_COR.REQUIRED_MESSAGE,
      },
    ],
  },
  website: {
    required: {
      [UserRoles.Supplier]: false,
      [UserRoles.Operator]: false,
    },
    disabled: {
      [UserRoles.Supplier]: false,
      [UserRoles.Operator]: false,
    },
    validationRules: [
      {
        type: 'pattern',
        value: allSymbolsAndEnglishLettersRegex,
        message: CONTACT_INFORMATION_FORM_VALUES.URL.VALIDATION_MESSAGE,
      },
    ],
  },
}

export const requiredFields = {
  [CONTACT_INFORMATION_FORM_VALUES.NAME.ID]:
    CONTACT_INFORMATION_FORM_VALUES.NAME.REQUIRED_MESSAGE,
  [CONTACT_INFORMATION_FORM_VALUES.POSTAL_CODE.ID]:
    CONTACT_INFORMATION_FORM_VALUES.POSTAL_CODE.REQUIRED_MESSAGE,
  [CONTACT_INFORMATION_FORM_VALUES.COUNTRY.ID]:
    CONTACT_INFORMATION_FORM_VALUES.COUNTRY.REQUIRED_MESSAGE,
  [CONTACT_INFORMATION_FORM_VALUES.STREET.ID]:
    CONTACT_INFORMATION_FORM_VALUES.STREET.REQUIRED_MESSAGE,
  [CONTACT_INFORMATION_FORM_VALUES.BUILDING.ID]:
    CONTACT_INFORMATION_FORM_VALUES.BUILDING.REQUIRED_MESSAGE,
  [CONTACT_INFORMATION_FORM_VALUES.CITY.ID]:
    CONTACT_INFORMATION_FORM_VALUES.CITY.REQUIRED_MESSAGE,
  [CONTACT_INFORMATION_FORM_VALUES.EMAIL.ID]:
    CONTACT_INFORMATION_FORM_VALUES.EMAIL.REQUIRED_MESSAGE,
  [CONTACT_INFORMATION_FORM_VALUES.CONTACT_PERSON_NAME.ID]:
    CONTACT_INFORMATION_FORM_VALUES.CONTACT_PERSON_NAME.REQUIRED_MESSAGE,
  [CONTACT_INFORMATION_FORM_VALUES.BRAND_NAME.ID]:
    CONTACT_INFORMATION_FORM_VALUES.BRAND_NAME.REQUIRED_MESSAGE,
  [CONTACT_INFORMATION_FORM_VALUES.LOGO.ID]:
    CONTACT_INFORMATION_FORM_VALUES.LOGO.REQUIRED_MESSAGE,
}
